import { Box, Divider, ListItemIcon, ListItemText, MenuItem, MenuList, Modal, Typography } from '@mui/material'
import React, { useState } from 'react'
import CollectionsIcon from '@mui/icons-material/Collections'
import HeaderButtonForBusiness from './HeaderButtonForBusiness'
import DrawIcon from '@mui/icons-material/Draw'
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh'
import ForumIcon from '@mui/icons-material/Forum'
import ArticleIcon from '@mui/icons-material/Article'
import TollIcon from '@mui/icons-material/Toll'
import ModalCredits from '../modules/ModalCredits'

const HeaderMenuMobile = (props) => {

  const [ isModalCreditsVisible, setIsModalCreditsVisible ] = useState(false);

  const handleModalCreditsOpen = () => setIsModalCreditsVisible(true);
  const handleModalCreditsClose = () => setIsModalCreditsVisible(false);


  return (
    <Box>
      <Box sx={{display: "flex", flexWrap: "wrap", px:1,}}>
        <Box sx={{m:1, minWidth: 200,}}>
          <Typography variant="h6">How to Buy</Typography>
          <MenuList disablePadding>
            <MenuItem component="a" href="/pro/">
              <ListItemIcon>
                <Typography fontSize={10} sx={{backgroundColor: "#b71c1c", borderRadius: 1, color: "#ffffff", px:.75,}}>Pro</Typography>
              </ListItemIcon>
              <ListItemText>Pricing</ListItemText>
            </MenuItem>
            <MenuItem onClick={handleModalCreditsOpen}>
              <ListItemIcon>
                <TollIcon />
              </ListItemIcon>
              <ListItemText>Buy Credits</ListItemText>
            </MenuItem>
            <Modal
              open={isModalCreditsVisible}
              onClose={handleModalCreditsClose}
              aria-labelledby="modal-modal-credits"
              aria-describedby="modal-modal-buy-credits"
            >
              <ModalCredits handleModalCreditsClose={handleModalCreditsClose} />
            </Modal>
            <MenuItem component="a" href="/business/">
              <HeaderButtonForBusiness />
            </MenuItem>
          </MenuList>
        </Box>
        <Box sx={{m:1, minWidth: 200,}}>
          <Typography variant="h6">Inspiration</Typography>
          <MenuList disablePadding>
            <MenuItem component="a" href="/gallery/">
              <ListItemIcon>
                <CollectionsIcon />
              </ListItemIcon>
              <ListItemText>Gallery</ListItemText>
            </MenuItem>
            <MenuItem component="a" href="https://designer.personalarch.com/home/profile?tab=0">
              <ListItemIcon>
                <DrawIcon />
              </ListItemIcon>
              <ListItemText>Templates</ListItemText>
            </MenuItem>
          </MenuList>
        </Box>
        <Box sx={{m:1, minWidth: 200,}}>
          <Typography variant="h6">Resources</Typography>
          <MenuList disablePadding>
            <MenuItem component="a" href="/features/">
              <ListItemIcon>
                <AutoFixHighIcon />
              </ListItemIcon>
              <ListItemText>Features</ListItemText>
            </MenuItem>
            <MenuItem component="a" href="https://community.personalarch.com/">
              <ListItemIcon>
                <ForumIcon />
              </ListItemIcon>
              <ListItemText>Community</ListItemText>
            </MenuItem>
            <MenuItem component="a" href="/posts/">
              <ListItemIcon>
                <ArticleIcon />
              </ListItemIcon>
              <ListItemText>Articles</ListItemText>
            </MenuItem>
          </MenuList>
        </Box>
      </Box>
      <Divider />
      <MenuList>
        <MenuItem
          component="a"
          href="https://www.cadsoft.com"
        >
          <ListItemIcon>
            <Box
              component="img"
              src={
                process.env.NODE_ENV === 'development' ? 
                  "/assets/svg/marks/primary/envisioneer.svg" : 
                  "/wp-content/themes/personal-architect/assets/svg/marks/primary/envisioneer.svg"
              }
              sx={{width: 24, height: 24,}}
            />
          </ListItemIcon>
          <ListItemText>Visit Cadsoft</ListItemText>
        </MenuItem>
      </MenuList>
    </Box>
  )
}

export default HeaderMenuMobile